import React from "react";
import { Icon, Menu, MenuItem } from "@mui/material";
import { withRouter } from "react-router-dom";
import styles from "./styles.module.scss";
import clsx from "clsx";
import Ripple from "./Component/Ripple";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ReportEgretVerticalNavExpansionPanel = (props) => {
  const {
    item,
    shouldRenderLevel
  } = props;

  const { name, icon, badge, children = [] } = item;

  const { t } = useTranslation();


  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const renderChildren = children => children?.map((subItem, subIndex) => {
    if (shouldRenderLevel(subItem)) {
      if (subItem?.children?.length > 0) {
        return (
          <React.Fragment key={subIndex}>
            <MenuItem>
              <span className="font-weight-bold text-middle item-text">{`${t(subItem.name)}`}</span>
              <Icon className="item-icon text-middle">expand_more_icon</Icon>
              <div className="mx-auto"></div>
            </MenuItem>
            {renderChildren(subItem.children)}
          </React.Fragment>
        )
      }
      if (subItem.path) {
        return (
          <NavLink key={subIndex} to={subItem.path} className="nav-item" onClick={handleClose}>
            <MenuItem>
              <span className="text-middle item-text">{`${t(subItem.name)}`}</span>
              <div className="mx-auto"></div>
            </MenuItem>
          </NavLink>
        )
      }
      return (
        <MenuItem key={subIndex} onClick={handleClose}>
          {(() => {
            if (subItem.icon) {
              return (
                <Icon className="item-icon text-middle">{subItem.icon}</Icon>
              );
            }
            return (
              <span className="item-icon icon-text">{subItem.iconText}</span>
            );
          })()}
          <span className="text-middle item-text">{`${t(subItem.name)}`}</span>
          <div className="mx-auto"></div>
        </MenuItem>
      )

    }
    return null
  })

  const id = "mega-positioned-menu" + name
  return (
    <div className="wrapper-mega-positioned-menu">
      <button
        className={clsx(
          styles["touch-ripple"],
          "nav-item flex-middle h-48 w-100")}
        onClick={handleClick}
        aria-controls={open ? id : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        <div className="d-flex left">
          <Icon className="text-middle item-icon">{icon}</Icon>
          <span className="text-middle pl-8 item-text">{t(name)}</span>
        </div>
        {badge && (
          <div className={`badge bg-${badge.color}`}>{badge.value}</div>
        )}
        <div
          className={
            !open
              ? styles.collapseIcon + " item-arrow"
              : styles.expandIcon + " item-arrow"
          }
        >
          <Icon className="text-middle">chevron_right</Icon>
        </div>
        <Ripple />
      </button>
      <Menu
        disablePortal
        keepMounted
        disableScrollLock
        id={id}
        className="mega-positioned-menu"
        aria-labelledby="mega-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left"
        }}
      >
        {renderChildren(children)}
      </Menu>
    </div>
  )
}

export default withRouter(React.memo(ReportEgretVerticalNavExpansionPanel));
